import { dateISOToMMMddyyyy } from 'Data/format.js'

export function dueDate(value) {
  return (value && dateISOToMMMddyyyy(value)) || '-'
}
